import { Children, cloneElement, isValidElement, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { gsap, useGSAP } from 'src/utils/gsap';
import { prefersReducedMotion } from 'src/utils/motion';

// Non-breaking spaces stay inside words
const SPACE = /([ \t\n\r]+)/;

const splitWords = (node) => {
  if (typeof node === 'string') {
    return node.split(SPACE).map((part, i) =>
      !part || SPACE.test(part) ? (
        part
      ) : (
        <span
          key={i}
          className='w'
        >
          <span className='wi'>{part}</span>
        </span>
      )
    );
  }
  if (isValidElement(node)) return cloneElement(node, undefined, Children.map(node.props.children, splitWords));
  return node;
};

export default function SplitText({ as: Tag = 'span', reveal = false, children, ...rest }) {
  const ref = useRef(null);
  const revealed = useRef(false);
  const { i18n } = useTranslation();

  useGSAP(
    () => {
      if (!reveal || prefersReducedMotion || revealed.current) return;

      gsap.from(ref.current.querySelectorAll('.wi'), {
        yPercent: 115,
        duration: 1.3,
        ease: 'expo.out',
        stagger: 0.045,
        scrollTrigger: {
          trigger: ref.current,
          start: 'top 86%',
          onEnter: () => (revealed.current = true)
        }
      });
    },
    { scope: ref, dependencies: [i18n.language], revertOnUpdate: true }
  );

  return (
    <Tag
      ref={ref}
      {...rest}
    >
      {Children.map(children, splitWords)}
    </Tag>
  );
}
